import { useNavigate } from 'react-router-dom';
import type { ShareReadingRequest } from '@tarot/shared';
import { useMe } from '../auth/useMe';
import { stashReading } from './pendingSave';
import { CardsIcon } from '../../components/icons';

/**
 * 비회원에게만 보이는 저장 유도 — 결과를 본 직후가 회원 전환율이 가장 높은 순간이다.
 * 로그인하러 가기 전에 결과를 맡겨두고(stashReading), 돌아오면 자동 발행된다.
 * 회원은 이미 자동 저장되므로 아무것도 보여주지 않는다.
 */
export function SaveCta({ shareData }: { shareData: ShareReadingRequest | null }) {
  const { me, isLoading } = useMe();
  const navigate = useNavigate();

  if (isLoading || me || !shareData) return null;

  return (
    <section className="flex flex-col items-center gap-2.5 rounded-2xl border border-gold/25 bg-gold/5 p-4 text-center">
      <p className="flex items-center gap-1.5 text-sm font-semibold">
        <CardsIcon className="h-5 w-5 text-gold" />이 결과, 저장해 둘까요?
      </p>
      <p className="text-xs leading-relaxed text-moon-dim">
        로그인하면 <b className="text-moon">지난 타로</b>에 저장돼 언제든 다시 볼 수 있어요.
        <br />
        이름·이메일은 받지 않고, 지금 보고 있는 이 결과가 그대로 저장돼요.
      </p>
      <button
        onClick={() => {
          stashReading(shareData); // 로그인 후 돌아오면 자동 발행
          navigate('/login');
        }}
        className="w-full max-w-xs rounded-2xl bg-gold px-6 py-3 font-semibold text-night transition hover:bg-gold-deep"
      >
        로그인하고 이 결과 저장하기
      </button>
    </section>
  );
}
